// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/StarRating/styles.css
// module id = 3738
// module chunks = 33